<script lang="ts">
  import Button from '$shared/atoms/Button/Button.svelte';
  import { ButtonStyle } from '$shared/constants/ButtonStyle';

  const DefaultOkLabel = 'Done';
  const DefaultCancelLabel = 'Cancel';

  interface Props {
    okLabel?: string;
    reverse?: boolean;
    cancelLabel?: string;
    hideCancel?: boolean;
    loading?: boolean;
    disabled?: boolean;
    onok?: () => void;
    oncancel?: () => void;
  }

  let {
    okLabel = '',
    reverse = false,
    cancelLabel = '',
    hideCancel = false,
    loading = false,
    disabled = false,
    onok,
    oncancel
  }: Props = $props();

  const onClickOk = (): void => {
    onok?.();
  };

  const onClickCancel = (): void => {
    oncancel?.();
  };
</script>

<div class="comp-confirm-actions" class:reverse>
  <div class="action">
    <Button
      tabIndex={1}
      {disabled}
      {loading}
      style={ButtonStyle.Primary}
      name={okLabel || DefaultOkLabel}
      onclick={onClickOk}>{okLabel || DefaultOkLabel}</Button
    >
  </div>
  {#if !hideCancel}
    <div class="action">
      <Button tabIndex={1} name={cancelLabel || DefaultCancelLabel} onclick={onClickCancel}
        >{cancelLabel || DefaultCancelLabel}</Button
      >
    </div>
  {/if}
</div>

<style>
  .comp-confirm-actions {
    display: flex;
    align-items: center;
  }
  .comp-confirm-actions.reverse {
    flex-direction: row-reverse;
    justify-content: flex-end;
  }
  .comp-confirm-actions .action:not(:last-child) {
    margin-right: 16px;
  }
  .comp-confirm-actions.reverse .action:not(:last-child) {
    margin-left: 16px;
    margin-right: 0;
  }
</style>
